import { apiFetch } from './apiClient';



/* perguntas são sempre de UM cliente -- params: { clienteId, setor, incluirInativas } */
export const listarPerguntasFechamento = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.clienteId) qs.set('cliente_id', params.clienteId);
  if (params.setor) qs.set('setor', params.setor);
  if (params.incluirInativas) qs.set('incluir_inativas', 'true');
  const s = qs.toString();
  return apiFetch(`/perguntas-fechamento${s ? `?${s}` : ''}`);
};

export const criarPerguntaFechamento = (clienteId, setor, texto) =>
  apiFetch('/perguntas-fechamento', { method: 'POST', body: JSON.stringify({ cliente_id: clienteId, setor, texto }) });

export const atualizarPerguntaFechamento = (id, dados) =>
  apiFetch(`/perguntas-fechamento/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });

export const listarConfirmacoesFechamento = (clienteId, competencia) =>
  apiFetch(`/perguntas-fechamento/confirmacoes?cliente_id=${encodeURIComponent(clienteId)}&competencia=${encodeURIComponent(competencia)}`);

export const confirmarPerguntaFechamento = (perguntaId, clienteId, setor, competencia, confirmado) =>
  apiFetch('/perguntas-fechamento/confirmacoes', {
    method: 'PATCH',
    body: JSON.stringify({ pergunta_id: perguntaId, cliente_id: clienteId, setor, competencia, confirmado }),
  });
